@use "../../scss/breakpoints";
@use "../../scss/colors";

$header-color: #0478c9;
$mobile-margin: 6px;

@keyframes fade-in {
	to {
		opacity: 1;
	}
}

@keyframes fade-out {
	to {
		opacity: 0;
	}
}

.navigation {
	// this is an invisible background color with a blur effect
	background: none;
	box-shadow:
		0 4px 4px 0 rgba(50, 50, 71, 0.08),
		0 4px 8px 0 rgba(50, 50, 71, 0.06);
	backdrop-filter: blur(6px);
	height: 135px;
	display: flex;
	flex-direction: row;
	justify-content: space-between;
	padding: 0 64px;
	position: relative;
	z-index: 2;

	&.darkNavigation {
		.leftNav {
			li {
				a,
				button {
					color: colors.$nordic_dark_grey;
				}
			}
		}
	}

	@include breakpoints.sm-down {
		display: none;
	}

	@include breakpoints.xs {
		flex-direction: column;
	}

	ul {
		margin: 0;
		padding: 0;
	}

	.nordicBrand {
		img {
			height: 87px;
			width: 158px;
		}
	}

	.leftNav {
		align-items: center;
		display: flex;
		flex-direction: row;
		justify-content: center;
		list-style-type: none;
		padding-left: 0;
		gap: 40px;

		text-align: center;

		@include breakpoints.lg-down {
			gap: 24px;
		}

		@include breakpoints.md-down {
			gap: 18px;
		}

		.nordicBrandDesktop {
			@include breakpoints.sm-down {
				display: none;
			}
		}

		.link {
			color: colors.$white;
			font-size: 16px;
			font-weight: 350;
			letter-spacing: 1.1px;
			transition: none;
			opacity: 1;

			&:hover,
			&:focus-visible {
				opacity: 0.35;
				text-decoration: none;
			}

			&.active {
				text-decoration: underline;
				pointer-events: none;
				cursor: default;
				&:hover,
				&:focus-visible {
					opacity: 1;
					cursor: default;
					text-decoration: underline;
				}
			}
		}
	}

	.rightNav {
		align-items: center;
		display: flex;
		flex-direction: row;
		gap: 24px;
		justify-content: center;
		list-style: none;

		@include breakpoints.md-down {
			flex-direction: column;
			gap: 14px;
			margin: 10px 0;
		}
	}
}

// Mobile Navigation
.navigationMobile {
	background: none !important;
	display: none;
	position: relative;
	z-index: 11;

	@include breakpoints.sm-down {
		display: block;
	}

	.navigationMobileHeader {
		display: flex;
		display: none;
		flex-direction: row;
		justify-content: space-between;
		background: none !important;
		position: relative;
		padding: 24px 32px;
		height: 132px;
		.mobileLogo {
			z-index: 13;
			img {
				width: 158px;
				height: 84px;
			}
		}

		@include breakpoints.md-down {
			display: flex;
		}

		.mobileHamburger {
			z-index: 13;
			button {
				align-items: center;
				background-color: colors.$white;
				border: 1px solid colors.$nordic_dark_grey;
				display: grid;
				height: 40px;
				justify-content: center;
				margin-top: 8px;
				width: 40px;
				&:enabled {
					cursor: pointer;
				}
			}
		}
	}

	.lightNavigationMobile {
		box-shadow: none;
	}

	&.darkNavigationMobile {
		box-shadow:
			0 4px 4px 0 rgba(50, 50, 71, 0.08),
			0 4px 8px 0 rgba(50, 50, 71, 0.06);
		nav {
			&.mobileShown {
				&::before {
					content: "";
					position: absolute;
					top: 0;
					left: 0;
					width: 100%;
					height: 100%;
					background: colors.$white;
					z-index: 0;
				}
			}
			li {
				a {
					color: colors.$nordic_dark_grey;
					&.active {
						pointer-events: none;
						cursor: default;
						span {
							background-color: colors.$nordic_light_grey;
							border-radius: 4px;
							color: colors.$nordic_dark_grey;
							padding: 2px 6px;
						}
					}
				}
				hr {
					border-top: 2px solid rgba(0, 0, 0, 0.15);
					width: 89%;
					margin: 0 auto;
				}
			}
			.mobileSubmenuToggleRow > span {
				color: colors.$nordic_dark_grey;
			}
		}
	}

	nav {
		position: absolute;
		top: -132px;
		left: 0;
		width: 100%;
		height: 100vh;
		max-height: 0;
		opacity: 0;
		transition: opacity 0.5s;
		padding-top: 132px;
		z-index: 11;
		background-image: radial-gradient(
			ellipse at top left,
			colors.$nordic_lake 0%,
			colors.$nordic_blueslate 100%
		);

		&.mobileShown {
			position: relative;
			display: flex;
			flex-direction: column;
			min-height: 100vh;
			max-height: none;
			height: auto;
			opacity: 1;

			background: radial-gradient(
				ellipse at top left,
				#{colors.$nordic_lake} 0%,
				#{colors.$nordic_blueslate} 100%
			);

			&::before {
				content: "";
				position: absolute;
				top: 0;
				left: 0;
				width: 100%;
				height: 100%;
				background: url("/img/landing-page/nRF_Cloud_Hero_2025.svg") center /
					cover no-repeat;
				z-index: 0;
			}

			/* make sure menu/content stays on top */
			> * {
				position: relative;
				z-index: 1;
			}
		}
		ul {
			margin: 0;
			padding: 0;

			li {
				a {
					color: #fff;
					font-size: 40px;
					font-style: normal;
					font-weight: 350;
					line-height: 140%;
					letter-spacing: -0.4px;
					display: block;
					padding: 24px;

					opacity: 1;

					&:hover {
						opacity: 0.35;
					}

					&.active {
						opacity: 1;

						span {
							background-color: colors.$nordic_light_grey;
							border-radius: 4px;
							color: colors.$nordic_dark_grey;
							padding: 0 6px;
						}
					}
				}

				hr {
					border-top: 2px solid rgba(255, 255, 255, 0.4);
					width: 89%;
					margin: 0 auto;
				}
			}
		}

		.mobileSubmenuToggleRow {
			> span {
				color: #fff;
				font-size: 40px;
				font-weight: 350;
				line-height: 140%;
				letter-spacing: -0.4px;
				display: flex;
				align-items: center;
				justify-content: space-between;
				padding: 24px;
				cursor: pointer;
				opacity: 1;

				&:hover {
					opacity: 0.35;
				}
			}
		}

		.mobileSubmenuToggleContent {
			display: inline-flex;
			align-items: center;
			gap: 12px;
			width: 100%;
			justify-content: space-between;

			i {
				font-size: 36px;
			}
		}

		.mobileSubmenu {
			list-style: none;
			margin: 0;
			padding: 0;
			padding-bottom: 16px;

			li a {
				font-size: 28px;
				padding: 12px 24px 12px 48px;
			}
		}
	}
}
